<template>
    <div style="width: 100%;">
    <el-autocomplete class="x-auto-complete" style="width: 100%;" :model-value="title" @update:model-value="value=>change(value)" :clearable="true" :fetch-suggestions="querySearch"
        :placeholder="config.placeholder" :disabled="config.readonly" @select="selectHandler" @clear="clearHandler">
        <template #suffix>
            <el-icon class="el-input__icon">
                <Edit />
            </el-icon>
        </template>
        <template #default="{ item }">
            <div class="name">{{ getOptionsItemTitle(item, nameField) }}</div>
            <span v-if="!!item.desc">{{ item.desc }}</span>
        </template>
    </el-autocomplete>
</div>
</template>
<script setup>
import { ref, defineProps, watch, getCurrentInstance } from 'vue';
// @ts-ignore
import { Edit } from '@element-plus/icons-vue';
import ConfigCenter from '../../configs/ConfigCenter';
import ModuleCenter from '../../datamodule/ModuleCenter';
// import getTypeSearchData from '../../data/DefaultTypeSearchDatas';
// const inst = getCurrentInstance();
// const selectedView = ref({ value: null, label: null, data: null });
const inst = getCurrentInstance();

const props = defineProps({
    config: { default: null },
    readonly: { default: false },
    modelValue: { default: null },
    data: { default: null },
    field: { default: null },
})

const nameField = ref('name');
const keyField = ref('id');

const getQueryConfig = (config)=> {
    if (config instanceof Object) {
        return config;
    } else {
        return ConfigCenter.getConfig(config);
    }
}

const config = getQueryConfig(props.config?.config);
nameField.value = config.nameField;
keyField.value = config.keyField;

const getOptionsItemTitle = (data, nameField)=> {
    if (!data) return '';
    if (nameField instanceof Array) {
        const title = [];
        for (const f of nameField) {
            title.push(data[f] == null ? '' : data[f]);
        }
        return title.join(' -- ');
    } else {
        return data[nameField];
    }
}

const title = ref('');
watch(() => title, (value) => {
    console.log('title change', value);
})
watch(()=>props.modelValue, async (value)=> {
    if (!value) {
        title.value = '';
    } else {
        const module = ModuleCenter.getModule(config.module);
        const data = value != ' ' ? await module.getByKey(value, keyField.value) : null;
        // title.value = data ? data[nameField.value] : '';
        if (data != null) title.value = getOptionsItemTitle(data, nameField.value);
    }
}, {immediate:true})

const getQuery = (queryConfig, data)=> {
    if (!queryConfig) return {};
    const query = {};
    const options = {};
    queryConfig = queryConfig.replace(/([\w\,\.\:]+?)\?\{(\w+)\}/g, ($0, $1, $2)=> {
        let keys = $1;
        let v = data[$2];
        if (v == null) v = '';
        keys = keys.split(/[\,\.\:]/);
        const key = keys.shift();
        const value = [keys, ['' + v]];
        query[key] = value;
        options[key] = 'multi-relate';
        return '';
    })
    queryConfig = queryConfig.replace(/(\w+)\=\{(\w+)\}/g, ($0, $1, $2)=> {
        const v = data[$2];
        if (v != null) query[$1] = v;
        return '';
    })
    queryConfig = queryConfig.replace(/(\w+)\=([^\s\&]+)/g, ($0, $1, $2)=> {
        const key = $1
        let value = $2.split(/\s*\,\s*/);
        value = value.map((v)=>JSON.parse(v));
        if (value.length == 1) value = value[0];
        query[key] = value;
        return '';
    })
    return {query:query, options:options};
}
const querySearch = async (queryString, cb)=> {
    const config = getQueryConfig(props.config?.config);
    nameField.value =config.nameField
    keyField.value = config.keyField;
    const queryParams = {query:{}, options:{}};
    queryParams.query[Array.isArray(config.nameField)?config.nameField[0]:config.nameField] = queryString;
    queryParams.options[Array.isArray(config.nameField)?config.nameField[0]:config.nameField] = "like";
    // console.log(queryParams.value,Array.isArray()?config.nameField[0]:config.nameField)
    const def = getQuery(config?.query, props.data);
    Object.assign(queryParams.query, def.query);
    Object.assign(queryParams.options, def.options);
    console.log(def);
    const module = ModuleCenter.getModule(config.module);
 
    const result = await module.queryDatasMute(queryParams, null, { pageNumber: 1, pageSize: 10, total: 0 }, null);
    console.log(result);
    cb(result);
}

defineEmits({
    'update:modelValue': null,
})

const change = (value)=> {
    if (value !== undefined && value != '') {
        title.value = value;
        inst.emit('update:modelValue', ' ');
    } else if (value == '') {
        title.value = value;
        inst.emit('update:modelValue', null);
    }
}

const selectHandler = (data)=> {
    inst.emit('update:modelValue', data ? data[keyField.value] : null);
}
const clearHandler = ()=> {
    inst.emit('update:modelValue', null);
}
// const fill = (data, datas, fieldmap, keyProp, viewProp) => {
//     if (!viewProp) viewProp = 'name';
//     if (!datas) return data;
//     let name = null;
//     const isArray = datas instanceof Array;
//     if (data) {
//         if (!isArray) {
//             name = { label: datas[viewProp], value: datas[keyProp], data: data };
//         } else {
//             name = [];
//             for (let i = 0; i < datas.length; i++) {
//                 name.push({ label: datas[i][viewProp], value: datas[i][keyProp], data: datas[i] });
//             }
//         }
//         // console.log(data, 'data', datas);
//         for (const [key, value] of Object.entries(fieldmap)) {
//             if (!isArray) {
//                 data[key] = datas ? datas[value] : null;
//             } else {
//                 data[key] = [];
//                 for (var i = 0; i < datas.length; i++) {
//                     data[key].push(datas[i][value]);
//                 }
//             }
//         }
//     }
//     return name;
// }
// const listFill = (data, datas, fieldmap, keyProp, viewProp) => {
//     if (fieldmap) {
//         const map = Object.assign({}, fieldmap);
//         if (keyProp || viewProp) {
//             let hasKey = false;
//             let hasView = false;
//             // @ts-ignore
//             for (const [mapField, field] of Object.entries(map)) {
//                 if (field == keyProp) hasKey = true;
//                 if (field == viewProp) hasView = true;
//                 if (hasKey && hasView) break;
//             }
//             if (keyProp && !hasKey) map[keyProp] = keyProp;
//             if (viewProp && !hasView) map[viewProp] = viewProp;
//         }
//         const isArray = datas instanceof Array;
//         if (!isArray) datas = [datas];
//         const mapDatas = [];
//         // @ts-ignore
//         datas.forEach((d, index) => {
//             const mapd = {};
//             for (const [mapField, field] of Object.entries(map)) {
//                 mapd[mapField] = d[field];
//             }
//             mapDatas.push(mapd);
//             data.push(mapd);
//         })
//         return mapDatas;
//     } else {
//         // @ts-ignore
//         datas.forEach((d, index) => {
//             data.push(d);
//         })
//         return datas;
//     }
// }

// // @ts-ignore
// const querySearch = (queryString, cb) => {
//     if (queryString == '') {
//         selectedView.value.value = null;
//         changeByView(selectedView.value);
//         fillData({});
//     }
//     console.log(props.config)
//     // console.log('prepare search', queryString, title.value);
    
//     if (!queryString || queryString != title.value) {
//         cb([]);
//         return;
//     }
//     if (!!props.config.targetModule || !!props.config.targetField) {
         
//         // const urlInfo = formatDataUrl(typeSearchData.queryUrl || props.queryUrl, props.data);
//         // const queryData = {};
//         // queryData[typeSearchData.viewProp || props.viewProp] = queryString;
//         // queryDatas(urlInfo.url, { pageNum: 1, pageSize: props.maxCount }, Object.assign(queryData, urlInfo.params, urlInfo.body), true).then((data) => {
//         //     cb(transformDatas(data.list));
//         // })
//     } else if (!!props.queryDatas) {
//         const list = props.queryDatas.filter((data) => {
//             return data[typeSearchData.viewProp || props.viewProp].indexOf(queryString) === 0;
//         })
//         cb(transformDatas(list));
//     }
// }

// const transformDatas = (datas) => {
//     if (!datas || !datas.length) return [];
//     const list = [];
//     // @ts-ignore
//     const fieldmap = Object.assign({}, props.fieldmap);
//     // @ts-ignore
//     fieldmap.value = typeSearchData.keyProp || props.keyProp;
//     // @ts-ignore
//     fieldmap.name = typeSearchData.viewProp || props.viewProp;
//     // @ts-ignore
//     if (typeSearchData.descProp || props.descProp) fieldmap.desc = typeSearchData.descProp || props.descProp;
//     // @ts-ignore
//     datas.forEach((data, index) => {
//         const d = {};
//         for (const [mapField, field] of Object.entries(fieldmap)) {
//             d[mapField] = data[field];
//         }
//         d.data = data;
//         list.push(d);
//     })
//     return list;
// }

// let typeSearchData = {};

// defineEmits({
//     'update:modelValue': null,
//     'afterFillData': null,
// })


// const changeByView = (view) => {
//     inst.emit('update:modelValue', view ? view.value : null);
// }

// const fillSelectView = (value) => {
//     if (!props.data) return;
//     const keys = value;
//     let names = null;
//     const viewProp = typeSearchData.viewProp || props.viewProp;
//     if (viewProp && props.fieldmap) {
//         let namefield = null;
//         for (const [key, value] of Object.entries(props.fieldmap)) {
//             if (value == viewProp && props.data[key] != null) {
//                 namefield = key;
//             }
//         }
//         if (namefield) names = props.data[namefield];
//     }
//     if (title.value != names) title.value = names || '';
//     const tag = { value: keys, label: names, data: {} };
//     for (const [key, value] of Object.entries(props.fieldmap)) {
//         const d = props.data[key];
//         if (d != null) tag.data[value] = d;
//     }
//     selectedView.value = tag;
// }

// const fillData = (data) => {
//     // console.log('fill data', data);
//     const keyProp = typeSearchData.keyProp || props.keyProp;
//     const viewProp = typeSearchData.viewProp || props.viewProp;
//     if (props.fillType == 'objectFill') {
//         const value = fill(props.data, data, props.fieldmap, keyProp, viewProp);
//         inst.emit('afterFillData', props.data, value);
//     } else {
//         const value = listFill(props.data, data, props.fieldmap, keyProp, viewProp);
//         inst.emit('afterFillData', props.data, value);
//     }
// }

// watch(() => props.searchType, (value) => {
//     typeSearchData = value ? getTypeSearchData(value) : {};
//     fillSelectView(props.modelValue);
// }, { immediate: true })
// watch(() => props.modelValue, (value) => {
//     // console.log('model value change', value)
//     fillSelectView(value);
// }, { immediate: true })

// // @ts-ignore
// const selectHandler = (data) => {
//     //     console.log('selected', data);
//     selectedView.value.value = data.value;
//     changeByView(selectedView.value);
//     fillData(data.data);
// }
// // @ts-ignore
// const blurHandler = () => {
//     // console.log('blur');
// }

</script>